// Configuration for the Rolleston Homes application
export const config = {
  // CMS API Configuration
  cmsApiUrl:
    import.meta.env.VITE_CMS_API_URL || "http://localhost:3000/api/public",
  cmsApiKey:
    import.meta.env.VITE_CMS_API_KEY || "rolleston-homes-api-key-67890",
  websiteSlug: import.meta.env.VITE_WEBSITE_SLUG || "rolleston-homes",

  growthtradiesApiUrl:
    import.meta.env.VITE_GROWTHTRADIES_API_URL || "https://www.growthtradies.com",
  growthtradiesFormId:
    import.meta.env.VITE_GROWTHTRADIES_FORM_ID ||
    "3bce8f58-7084-4207-8c18-48e01a70f165",

  // Development Configuration
  devMode: import.meta.env.VITE_DEV_MODE === "true" || import.meta.env.DEV,

  // API Endpoints
  get pagesApiUrl() {
    return `${this.cmsApiUrl}/pages/${this.websiteSlug}`;
  },

  get postsApiUrl() {
    return `${this.cmsApiUrl}/posts/${this.websiteSlug}`;
  },

  // Headers for API requests
  get apiHeaders() {
    return {
      Authorization: `Bearer ${this.cmsApiKey}`,
      "Content-Type": "application/json",
    };
  },
};

export default config;
